import { capturePlanningSessionUpdate } from '../../../planning/planning-session-turn-buffer.js';
import { formatSessionUpdateKindForLog } from '../../format-session-update-kind-for-log.js';
import { errorMessage } from '../../../../error-message.js';
import type { LogFn } from '../../../../log.js';

export function forwardBridgeSessionUpdate(params: {
  runId: string;
  sessionId: string | undefined;
  updateKind: string;
  payload: unknown;
  send: (msg: unknown) => void;
  nextTranscriptStreamSeq?: (runId: string) => number | undefined;
  log: LogFn;
}): void {
  const { runId, sessionId, updateKind, payload, send, nextTranscriptStreamSeq, log } = params;

  if (updateKind === 'permission') {
    return;
  }
  if (capturePlanningSessionUpdate({ runId, updateKind, payload })) {
    return;
  }

  try {
    const transcriptStreamSeq = nextTranscriptStreamSeq?.(runId);
    send({
      type: 'session_update',
      ...(sessionId ? { sessionId } : {}),
      runId,
      kind: updateKind,
      payload,
      ...(transcriptStreamSeq != null ? { transcriptStreamSeq } : {}),
    });
  } catch (err) {
    log(
      `[Bridge service] Session update send failed (${formatSessionUpdateKindForLog(updateKind)}): ${errorMessage(err)}`,
    );
  }
}
